// Read-only: units are provisioned by ops, so nothing ever invalidates the tag.

import api from 'api'
import { CACHE_TAG_BUSINESS_UNIT_LIST } from 'api/cacheTagTypes'
import { BusinessUnitApi, BusinessUnitListResponseApi } from 'types/api/business-units/businessUnits'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getBusinessUnits: build.query<BusinessUnitApi[], void>({
      query: () => ({ url: '/api/v1/core/business-units' }),
      transformResponse: (response: BusinessUnitListResponseApi) => response.businessUnits,
      providesTags: [CACHE_TAG_BUSINESS_UNIT_LIST],
    }),
  }),
})

export const { useGetBusinessUnitsQuery } = extendedApi
